import React, {useMemo} from "react"
import {ScrollableTable, TableBody, TableHead} from "./ScrollableTable"
import {Box, TableCell, TableRow, useTheme} from "@mui/material"
import {getMerkmal} from "../../../misc/widget-functions"
import {fmtAlways} from "./AvRiesterTable"

const LeistungsphaseTable = ({widget, getDataFromPointer}) => {
    const pointer = getMerkmal(widget)?.pointer
    const data = getDataFromPointer(pointer) ?? {}

    const {
        secondary: bruttokapital,
        quartary: lebenslangeRente,
    } = useTheme()?.AvRiester ?? {}

    const tableRows = useMemo(
        () => [
            {
                key: "lebenslangeRente",
                label: "monatliche Nettorente",
                color: lebenslangeRente,
            },
            {
                key: "auszahlplan",
                label: "monatliche Auszahlung",
                color: bruttokapital,
            },
        ],
        [lebenslangeRente, bruttokapital],
    )

    return (
        <ScrollableTable noWrap>
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell align="right">Netto</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {tableRows.map(({key, label, color}) => (
                    <TableRow key={key}>
                        <TableCell>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                }}>
                                {color && (
                                    <Box
                                        sx={{
                                            width: 16,
                                            height: 16,
                                            borderRadius: "50%",
                                            bgcolor: color,
                                            flexShrink: 0,
                                        }}
                                    />
                                )}
                                {label}
                            </Box>
                        </TableCell>
                        <TableCell align="right">
                            {fmtAlways(data?.[key], false, 2)}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </ScrollableTable>
    )
}

export default LeistungsphaseTable
